// extracted by mini-css-extract-plugin
export default {"Card":"sNpDJARl"};